(function () {
  // Get the checkbox elements with class "js-selected-field"
  let checkboxes = document.querySelectorAll(
    ".js-evaluation-forms .js-selected-field"
  );

  // Loop through the checkboxes
  for (let i = 0; i < checkboxes.length; i++) {
    let checkbox = checkboxes[i];

    // Add an event listener to each checkbox
    checkbox.addEventListener("change", function (event) {
      // Check if the closest parent has class "js-process-form"
      if (event.target.closest(".js-process-form")) {
        // Update the text value inside the element with id "js-selected-process"
        let selectedProcessElements = document.getElementsByClassName(
          "js-selected-process"
        );
        for (let j = 0; j < selectedProcessElements.length; j++) {
          let selectedProcessElement = selectedProcessElements[j];
          let currentValue = parseInt(selectedProcessElement.textContent) || 0;

          if (event.target.checked) {
            selectedProcessElement.textContent = `${currentValue + 1}`;
          } else {
            selectedProcessElement.textContent = Math.max(currentValue - 1, 0);
          }
        }
      }

      // Check if the closest parent has class "js-impact-form"
      if (event.target.closest(".js-impact-form")) {
        // Update the text value inside the element with id "js-selected-impact"
        let selectedImpactElements =
          document.getElementsByClassName("js-selected-impact");
        for (let j = 0; j < selectedImpactElements.length; j++) {
          let selectedImpactElement = selectedImpactElements[j];
          let currentValue = parseInt(selectedImpactElement.textContent) || 0;

          if (event.target.checked) {
            selectedImpactElement.textContent = currentValue + 1;
          } else {
            selectedImpactElement.textContent = Math.max(currentValue - 1, 0);
          }
        }
      }
    });
  }
})();
